import TermUtils from 'utils/terms';

export function safeDecodeUri(actionPlan) {
    if (typeof actionPlan !== 'string') {
        return actionPlan;
    }
    /**
     * decodeURI can fail (and crash this app) when there is a single % symbol used to denote a percentage amount for a note
     * Before decodeURI runs
     * - check if single percentage symbol
     * - if yes, replace with encode %25 percentage
     */
    return decodeURI(actionPlan.replace(/%(?![0-9a-fA-F][0-9a-fA-F]+)/g, '%25'));
}

export function typicalGrowth(goal) {
    if (!goal.get('predictedGrowth')) {
        return {
            description: 'Performance goal',
            className: 'test-score-performance-goal',
        };
    }

    return {
        description: `${goal.get('predictedGrowth')}`,
        className: 'content-column-upcoming-goal-grid',
    };
}

export function startingScore(goal, includeTerm = false) {
    if (!goal.get('startTermScore')) {
        return {
            description: 'no starting score',
            className: 'test-score-performance-goal',
        };
    } else if (includeTerm) {
        return {
            description: `${TermUtils.textFromTermNumber(goal.get('startTermNumber'), true)}: ${goal.get(
                'startTermScore'
            )}`,
            className: 'content-column-upcoming-goal-grid',
        };
    }

    return {
        description: `${goal.get('startTermScore')}`,
        className: 'content-column-upcoming-goal-grid',
    };
}

export function endTermName(endTermNumber, highlightRowYn, editedRowYn) {
    const newOrUpdated = editedRowYn ? 'UPDATED' : 'NEW';
    return highlightRowYn
        ? `${newOrUpdated}: ${TermUtils.textFromTermNumber(endTermNumber, true)}`
        : TermUtils.textFromTermNumber(endTermNumber, true);
}

export function missingNormDataYn(growthGoalYn, percentileIfMet, typicalGrowth, typicalScore) {
    // intended for goal setting form
    if (!growthGoalYn) {
        return !typicalScore; // performance goals only require typical score
    }

    // growth goals require all
    return !typicalScore || !typicalGrowth || !percentileIfMet;
}

export default {
    endTermName,
    missingNormDataYn,
    safeDecodeUri,
    startingScore,
    typicalGrowth,
};
